export default __webpack_public_path__ + "static/media/soundsprofitable.7cc8eaaf.png";